import React from 'react';
import { Phone, Clock, MapPin, Shield, Key, Home, Building2, Car, Lock } from 'lucide-react';
export function LocksmithLanding() {
  return <div className="min-h-screen bg-slate-50" data-id="element-2">
      {/* Header */}
      <header className="bg-slate-900 text-white py-4 sticky top-0 z-50 shadow-lg" data-id="element-3">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center" data-id="element-4">
          <div className="flex items-center gap-2" data-id="element-5">
            <Shield className="w-8 h-8 text-amber-500" data-id="element-6" />
            <span className="text-xl font-bold" data-id="element-7">Shield Lock Systems</span>
          </div>
          <a href="tel:501-503-1950" className="bg-amber-500 hover:bg-amber-600 text-slate-900 px-6 py-2.5 rounded-lg font-semibold flex items-center gap-2 transition-colors" data-id="element-8">
            <Phone className="w-5 h-5" data-id="element-9" />
            <span className="hidden sm:inline" data-id="element-10">Call Now</span>
          </a>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative bg-slate-900 text-white overflow-hidden" data-id="element-11">
        <div className="absolute inset-0 opacity-20" data-id="element-12">
          <img src="https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=1600&q=80" alt="Professional locksmith" className="w-full h-full object-cover" data-id="element-13" />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 lg:py-32" data-id="element-14">
          <div className="max-w-3xl" data-id="element-15">
            <div className="inline-flex items-center gap-2 bg-amber-500/20 text-amber-400 px-4 py-2 rounded-full mb-6 border border-amber-500/30" data-id="element-16">
              <Clock className="w-4 h-4" data-id="element-17" />
              <span className="text-sm font-semibold" data-id="element-18">
                24/7 Emergency Service Available
              </span>
            </div>
            <h1 className="text-5xl lg:text-6xl font-bold mb-6 leading-tight" data-id="element-19">
              Little Rock's Most Trusted Locksmith Service
            </h1>
            <p className="text-xl text-slate-300 mb-8 leading-relaxed" data-id="element-20">
              Fast, reliable, and professional locksmith services for your home,
              business, and vehicle. Licensed, insured, and ready to help 24/7.
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-21">
              <a href="tel:501-503-1950" className="bg-amber-500 hover:bg-amber-600 text-slate-900 px-8 py-4 rounded-lg font-bold text-lg flex items-center justify-center gap-2 transition-colors shadow-lg" data-id="element-22">
                <Phone className="w-5 h-5" data-id="element-23" />
                501-503-1950
              </a>
              <a href="#services" className="bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white px-8 py-4 rounded-lg font-semibold text-lg flex items-center justify-center gap-2 transition-colors border border-white/20" data-id="element-24">
                View Services
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-20 bg-white" data-id="element-25">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-26">
          <div className="text-center mb-16" data-id="element-27">
            <h2 className="text-4xl font-bold text-slate-900 mb-4" data-id="element-28">
              Our Services
            </h2>
            <p className="text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-29">
              Comprehensive locksmith solutions for every security need
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-30">
            {/* Residential */}
            <div className="bg-slate-50 rounded-xl p-8 hover:shadow-xl transition-shadow" data-id="element-31">
              <div className="w-14 h-14 bg-amber-500 rounded-lg flex items-center justify-center mb-6" data-id="element-32">
                <Home className="w-7 h-7 text-slate-900" data-id="element-33" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-34">
                Residential
              </h3>
              <ul className="space-y-2 text-slate-600" data-id="element-35">
                <li data-id="element-36">• Lock installation & repair</li>
                <li data-id="element-37">• Home lockouts</li>
                <li data-id="element-38">• Rekeying services</li>
                <li data-id="element-39">• Smart lock installation</li>
                <li data-id="element-40">• Security upgrades</li>
              </ul>
            </div>

            {/* Commercial */}
            <div className="bg-slate-50 rounded-xl p-8 hover:shadow-xl transition-shadow" data-id="element-41">
              <div className="w-14 h-14 bg-amber-500 rounded-lg flex items-center justify-center mb-6" data-id="element-42">
                <Building2 className="w-7 h-7 text-slate-900" data-id="element-43" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-44">
                Commercial
              </h3>
              <ul className="space-y-2 text-slate-600" data-id="element-45">
                <li data-id="element-46">• Master key systems</li>
                <li data-id="element-47">• Access control</li>
                <li data-id="element-48">• High-security locks</li>
                <li data-id="element-49">• Office lockouts</li>
                <li data-id="element-50">• Panic bar installation</li>
              </ul>
            </div>

            {/* Automotive */}
            <div className="bg-slate-50 rounded-xl p-8 hover:shadow-xl transition-shadow" data-id="element-51">
              <div className="w-14 h-14 bg-amber-500 rounded-lg flex items-center justify-center mb-6" data-id="element-52">
                <Car className="w-7 h-7 text-slate-900" data-id="element-53" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-54">
                Automotive
              </h3>
              <ul className="space-y-2 text-slate-600" data-id="element-55">
                <li data-id="element-56">• Car lockouts</li>
                <li data-id="element-57">• Key replacement</li>
                <li data-id="element-58">• Transponder keys</li>
                <li data-id="element-59">• Ignition repair</li>
                <li data-id="element-60">• Key fob programming</li>
              </ul>
            </div>

            {/* Emergency */}
            <div className="bg-slate-50 rounded-xl p-8 hover:shadow-xl transition-shadow" data-id="element-61">
              <div className="w-14 h-14 bg-amber-500 rounded-lg flex items-center justify-center mb-6" data-id="element-62">
                <Lock className="w-7 h-7 text-slate-900" data-id="element-63" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-64">
                Emergency
              </h3>
              <ul className="space-y-2 text-slate-600" data-id="element-65">
                <li data-id="element-66">• 24/7 availability</li>
                <li data-id="element-67">• Fast response time</li>
                <li data-id="element-68">• Lockout assistance</li>
                <li data-id="element-69">• Lock repairs</li>
                <li data-id="element-70">• Security emergencies</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 bg-slate-900 text-white" data-id="element-71">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-72">
          <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-73">
            <div data-id="element-74">
              <h2 className="text-4xl font-bold mb-6" data-id="element-75">
                Why Choose Shield Lock Systems?
              </h2>
              <p className="text-xl text-slate-300 mb-8" data-id="element-76">
                With years of experience serving Little Rock and surrounding
                areas, we've built our reputation on trust, quality, and
                reliability.
              </p>

              <div className="space-y-6" data-id="element-77">
                <div className="flex gap-4" data-id="element-78">
                  <div className="w-12 h-12 bg-amber-500 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-79">
                    <Shield className="w-6 h-6 text-slate-900" data-id="element-80" />
                  </div>
                  <div data-id="element-81">
                    <h3 className="text-xl font-bold mb-2" data-id="element-82">
                      Licensed & Insured
                    </h3>
                    <p className="text-slate-300" data-id="element-83">
                      Fully licensed, bonded, and insured for your peace of
                      mind.
                    </p>
                  </div>
                </div>

                <div className="flex gap-4" data-id="element-84">
                  <div className="w-12 h-12 bg-amber-500 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-85">
                    <Clock className="w-6 h-6 text-slate-900" data-id="element-86" />
                  </div>
                  <div data-id="element-87">
                    <h3 className="text-xl font-bold mb-2" data-id="element-88">
                      24/7 Availability
                    </h3>
                    <p className="text-slate-300" data-id="element-89">
                      Emergency locksmith services available around the clock.
                    </p>
                  </div>
                </div>

                <div className="flex gap-4" data-id="element-90">
                  <div className="w-12 h-12 bg-amber-500 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-91">
                    <Key className="w-6 h-6 text-slate-900" data-id="element-92" />
                  </div>
                  <div data-id="element-93">
                    <h3 className="text-xl font-bold mb-2" data-id="element-94">
                      Expert Technicians
                    </h3>
                    <p className="text-slate-300" data-id="element-95">
                      Highly trained professionals with years of experience.
                    </p>
                  </div>
                </div>

                <div className="flex gap-4" data-id="element-96">
                  <div className="w-12 h-12 bg-amber-500 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-97">
                    <MapPin className="w-6 h-6 text-slate-900" data-id="element-98" />
                  </div>
                  <div data-id="element-99">
                    <h3 className="text-xl font-bold mb-2" data-id="element-100">Local & Trusted</h3>
                    <p className="text-slate-300" data-id="element-101">
                      Proudly serving the Little Rock community.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative" data-id="element-102">
              <img src="https://images.unsplash.com/photo-1582139329536-e7284fece509?w=800&q=80" alt="Professional locksmith at work" className="rounded-2xl shadow-2xl" data-id="element-103" />
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 bg-white" data-id="element-104">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-105">
          <div className="text-center mb-16" data-id="element-106">
            <h2 className="text-4xl font-bold text-slate-900 mb-4" data-id="element-107">
              Get In Touch
            </h2>
            <p className="text-xl text-slate-600" data-id="element-108">We're here to help 24/7</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto" data-id="element-109">
            <div className="text-center" data-id="element-110">
              <div className="w-16 h-16 bg-amber-500 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-111">
                <Phone className="w-8 h-8 text-slate-900" data-id="element-112" />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-113">Phone</h3>
              <a href="tel:501-503-1950" className="text-xl text-amber-600 hover:text-amber-700 font-semibold" data-id="element-114">
                501-503-1950
              </a>
            </div>

            <div className="text-center" data-id="element-115">
              <div className="w-16 h-16 bg-amber-500 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-116">
                <MapPin className="w-8 h-8 text-slate-900" data-id="element-117" />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-118">Address</h3>
              <p className="text-slate-600" data-id="element-119">
                4029 President Clinton
                <br data-id="element-120" />
                Business Dr
                <br data-id="element-121" />
                Little Rock, AR 72201
              </p>
            </div>

            <div className="text-center" data-id="element-122">
              <div className="w-16 h-16 bg-amber-500 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-123">
                <Clock className="w-8 h-8 text-slate-900" data-id="element-124" />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-125">Hours</h3>
              <p className="text-slate-600 font-semibold" data-id="element-126">
                24/7
                <br data-id="element-127" />
                Always Available
              </p>
            </div>
          </div>

          {/* Emergency CTA */}
          <div className="mt-16 bg-slate-900 rounded-2xl p-8 md:p-12 text-center" data-id="element-128">
            <h3 className="text-3xl font-bold text-white mb-4" data-id="element-129">
              Need Emergency Locksmith Service?
            </h3>
            <p className="text-xl text-slate-300 mb-8" data-id="element-130">
              We're available 24/7 for all your locksmith emergencies
            </p>
            <a href="tel:501-503-1950" className="inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-600 text-slate-900 px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-131">
              <Phone className="w-5 h-5" data-id="element-132" />
              Call Now: 501-503-1950
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-900 text-white py-12" data-id="element-133">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-134">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-135">
            <div className="flex items-center gap-2" data-id="element-136">
              <Shield className="w-6 h-6 text-amber-500" data-id="element-137" />
              <span className="font-bold" data-id="element-138">Shield Lock Systems</span>
            </div>
            <p className="text-slate-400 text-sm" data-id="element-139">
              © 2024 Shield Lock Systems. Licensed & Insured. Serving Little
              Rock, AR.
            </p>
          </div>
        </div>
      </footer>
    </div>;
}